import React from "react";
import { useTheme } from "styled-components";

const HTML = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m4.102 7.148-2.25-2.25a.563.563 0 0 1 0-.796l2.25-2.25a.563.563 0 1 1 .796.796L3.045 4.5l1.853 1.852a.563.563 0 1 1-.796.796m2.813 0a.563.563 0 0 0 .795 0l2.25-2.25a.56.56 0 0 0 0-.796l-2.25-2.25a.563.563 0 1 0-.795.796L8.767 4.5 6.915 6.352a.563.563 0 0 0 0 .796m7.148-4.336h-1.688a.562.562 0 1 0 0 1.125h1.688v10.125H3.938v-4.5a.563.563 0 0 0-1.125 0v4.5a1.125 1.125 0 0 0 1.125 1.125h10.125a1.125 1.125 0 0 0 1.124-1.125V3.937a1.125 1.125 0 0 0-1.124-1.125"
        fill={theme.text.text}
      />
    </svg>
  );
};

export default HTML;
